import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { ILauncher } from "../../../../models/application/i-launcher";
import { launcherRestClientInjectionToken } from "../../../../rest-clients/application/launcher/launcher-rest-client-injection-token";
import { ILauncherRestClient } from "../../../../rest-clients/application/launcher/i-launcher-rest.client";
import { IPage } from "@zaeper/communication-lib";

@Injectable()
export class LauncherPageResolver implements Resolve<IPage<ILauncher>> {
  constructor(@Inject( launcherRestClientInjectionToken ) private readonly _launcherRestClient: ILauncherRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IPage<ILauncher>> {
    return this._launcherRestClient.getApplicationPage( {
      pageNumber: 0,
      pageSize: 100
    } )
  }
}
